var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConductorLung75(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 80,
    viewBox: "0 0 118 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 68.25,
    x2: 118,
    y2: 68.25,
    stroke: "black",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConductorLung75);
export default __webpack_public_path__ + "static/media/conductor_lung_75.5e2107502cc336b2817ea27fa21745fe.svg";
export { ForwardRef as ReactComponent };